export const getDefaultPeriodRange = (referenceDate = new Date()) => {
  const toDate = new Date(
    referenceDate.getFullYear(),
    referenceDate.getMonth(),
    1
  )
  const fromDate = new Date(toDate.getFullYear(), toDate.getMonth() - 11, 1)
  return {
    fromMonth: fromDate.getMonth() + 1,
    fromYear: fromDate.getFullYear(),
    toMonth: toDate.getMonth() + 1,
    toYear: toDate.getFullYear(),
  }
}

export const getYearOptions = (referenceDate = new Date()) => {
  const currentYear = referenceDate.getFullYear()
  return Array.from({ length: 8 }, (_, i) => {
    const year = currentYear + 1 - i
    return { label: String(year), value: year }
  })
}

export const getMonthOptions = () => {
  const labels = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return labels.map((label, i) => ({
    label,
    value: i + 1,
  }))
}
